import React, { useState } from "react";
import RealEstateAgencyNotice from "../components/RealEstateAgencyNotice";

const ContactForm = () => {
  const initialFormState = {
    company: "",
    name: "",
    email: "",
    phone: "",
    message: "",
    consent: false,
  };

  const [formData, setFormData] = useState(initialFormState);
  const [status, setStatus] = useState("");

  const handleChange = ({ target: { name, value, type, checked } }) => {
    setFormData(prev => ({ ...prev, [name]: type === "checkbox" ? checked : value }));
  };

  const API_URL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:3000"
    : process.env.REACT_APP_API_URL;

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.consent) {
      setStatus("個人情報の取り扱いに同意してください。");
      return;
    }

    setStatus("送信中...");

    try {
      const response = await fetch(`${API_URL}/api/contact`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (response.ok) {
        setStatus("お問い合わせが送信されました。");
        setFormData(initialFormState);
      } else {
        setStatus(data.error || "送信に失敗しました。");
      }
    } catch (error) {
      console.error("送信エラー:", error);
      setStatus(`エラー: ${error.message}`);
    }
  };

  return (
    <div>
      <div className="mb-16 pt-16 text-center">
        <h1 className="text-3xl font-bold text-gray-800">お問合せ・採用</h1>
        <img src="/images/image4.png" alt="装飾ライン" className="mx-auto my-2 w-32" />
      </div>

      <div className="max-w-2xl mx-auto p-6 bg-white shadow-lg rounded-lg">
        <h2 className="text-xl font-bold text-gray-800 mb-4">お問い合わせについて</h2>

        <div className="text-sm text-gray-600">
          <p>・お問い合わせやご質問、ご相談についてはこちらよりお願い致します。お急ぎの際はお電話にてご連絡ください。</p>
          <p>・メールでのお問い合わせで2、3営業日たちましても回答がない場合はメールトラブルの可能性もございます。その際も下記のお電話にご連絡ください。</p>
          <p>・弊社が休業日中のお問い合わせについては翌営業日の対応とさせていただきます。</p>
        </div>

        <div className="text-center my-5 bg-gray-200 p-4">
          <p className="font-bold text-3xl">アプロ山梨株式会社</p>
          <p className="text-2xl">TEL：0555 (25) 6102</p>
          <p className="text-2xl">FAX：0555 (25) 6102</p>
          <p className="text-lg">Email：kawaguchiko@aprohd.jp</p>
          <p>受付時間 9:00～18:00 ※土日祝を除きます</p>
        </div>

        <div className="mt-4 rounded border border-gray-200 border-l-4 border-l-primary bg-gray-50 p-3 text-sm text-gray-700">
          <RealEstateAgencyNotice />
        </div>

        <h2 className="text-2xl font-bold text-gray-800 mt-16 text-center">お問い合わせフォーム</h2>

        <form onSubmit={handleSubmit} className="mt-4">
          {[
            { label: "会社名", name: "company", placeholder: "個人の方は「個人」とご記入してください" },
            { label: "お名前", name: "name" },
            { label: "Email", name: "email", required: true },
            { label: "電話番号", name: "phone", required: true },
          ].map(({ label, name, placeholder, required }) => (
            <div key={name}>
              <label className="block mt-4 mb-2">
                {label}
                {required && <span className="text-red-600 text-xs">*必須入力</span>}
              </label>
              <input
                type={name === "email" ? "email" : "text"}
                name={name}
                value={formData[name]}
                onChange={handleChange}
                placeholder={placeholder || ""}
                className="w-full p-2 border rounded"
              />
            </div>
          ))}

          <label className="block mt-4 mb-2">お問い合わせ内容<span className="text-red-600 text-xs">*必須入力</span></label>
          <textarea name="message" value={formData.message} onChange={handleChange} className="w-full p-2 border rounded h-32" />

          <div className="mt-6 p-4 bg-gray-200 rounded">
            <strong>個人情報の取扱について</strong>
            <p className="text-sm">当サイトは、お客様の個人情報について、お客様の承諾が無い限り第三者に開示、提供を一切いたしません。お客様から個人情報をご提供していただき、お客様へのサービスにご利用させていただく場合がありますが、その目的以外には利用いたしません。ご提供いただいた個人情報につきましては管理責任者を置き、適切な管理を行っております。</p>
          </div>

          <div className="mt-4">
            <input type="checkbox" name="consent" checked={formData.consent} onChange={handleChange} className="mr-2" />
            <span>個人情報の取り扱いについて確認しました</span>
          </div>

          <button type="submit" disabled={!formData.consent} className="mt-4 bg-primary text-white px-4 py-2 rounded disabled:bg-gray-400">送信する</button>
        </form>

        {status && <p className={`mt-4 text-center text-lg font-bold p-2 rounded ${status.includes("必須") ? "bg-red-500 text-white" : "text-gray-800"}`}>{status}</p>}
      </div>
    </div>
  );
};

export default ContactForm;
